<ng-container *ngIf="product.is_open">
  <div
    class="product__modal-title"
    *ngIf="isModalShown"
    [class]="isModalShown ? 'mr-3' : ''"
  >
    <button (click)="emitModalToggle()">
      <img src="assets/svg-icons/close.svg" alt="close tag" />
    </button>
  </div>

  <div *ngIf="isLoading" class="product__modal-title__loading">
    <div>
      <div class="text-center">
        <svg-icon
          name="circle-notch"
          [spin]="true"
          class="loader-icon__icon"
        ></svg-icon>
      </div>
    </div>
  </div>
  <div [ngClass]="{ 'product__tabs__native-app': isMobile }">
    <div class="product__tabs" id="product-tabs-section">
      <button
        type="button"
        [class.active-tab]="activeEntryOption === 'online'"
        (click)="chooseEntryOption('online')"
        >Online entry</button
      >
      <button
        type="button"
        [class.active-tab]="activeEntryOption === 'free'"
        (click)="chooseEntryOption('free')"
      >
        Free postal entry</button
      >
    </div>
    <div class="product__tab-wrap" *ngIf="activeEntryOption === 'online'">
      <form
        [formGroup]="formGroup"
        [class.product-quantity_updating]="isAddingToCart"
      >
        <div
          class="product__tab-content ticket"
          [class.ticket--error]="errorMessage"
        >
          <div class="alert alert_error" *ngIf="errorMessage">
            <div class="alert__text">{{ errorMessage }}</div>
          </div>

          <div
            class="ticket__tickets"
            [ngClass]="{ 'ticket__tickets--reset-padding': !entranceAvailable }"
          >
            <ng-container *ngIf="sliderMaxTickets > 1 && entranceAvailable">
              <div class="ticket__chooser-container">
                <mat-slider
                  [max]="sliderMaxTickets"
                  [min]="sliderMinTickets"
                  [step]="1"
                  [discrete]="true"
                  [ngClass]="{
                    max: sliderTicketQuantity >= (88 / 100) * sliderMaxTickets
                  }"
                  #ngSlider
                >
                  <input
                    matSliderThumb
                    (input)="
                      slideRangeInput({
                        source: ngSliderThumb,
                        parent: ngSlider,
                        value: ngSliderThumb.value
                      })
                    "
                    [formControl]="formGroup.controls.tickets"
                    #ngSliderThumb="matSliderThumb"
                  />
                </mat-slider>
              </div>

              <div class="ticket__labels">
                <span class="ticket__label">{{ sliderMinTickets }}</span>
                <span class="ticket__label">{{ sliderMaxTickets }}</span>
              </div>

              <div class="ticket__quantities">
                <div
                  class="product__price"
                  [ngClass]="{ 'product__price-new': oldPrice }"
                >
                  <span class="product__price-old" *ngIf="oldPrice">
                    {{ oldPrice | currency: currency }}
                  </span>
                  {{ price | currency: currency }}
                </div>
                <div class="ticket__quantities__actions">
                  <button
                    class="ticket__quantity"
                    [class.ticket__quantity--disabled]="
                      sliderTicketQuantity === sliderMinTickets
                    "
                    (click)="handleDecrement()"
                    >-</button
                  >
                  <div class="ticket__total">
                    <input
                      type="number"
                      [min]="sliderMinTickets"
                      [max]="sliderMaxTickets"
                      [value]="sliderTicketQuantity"
                      (change)="handleTicketChange($event)"
                      appOnlyNumbers
                    />
                  </div>
                  <button
                    [class.ticket__quantity--disabled]="
                      sliderTicketQuantity === sliderMaxTickets
                    "
                    class="ticket__quantity"
                    type="button"
                    (click)="handleIncrement()"
                    >+</button
                  >
                </div>
              </div>
            </ng-container>
            <div
              class="ticket__actions"
              [ngClass]="{
                'ticket__actions--reset-margin': !entranceAvailable
              }"
            >
              <div class="ticket__actions-sumary" *ngIf="entranceAvailable">
                <span class="sumary-bolder">
                  Total
                  <span class="sumary-light">
                    ({{ sliderTicketQuantity }} Tickets)
                  </span>
                </span>
                <span class="sumary-bolder">
                  {{ sliderTicketQuantity * price | currency: currency }}
                </span>
              </div>
              <button
                [ngClass]="{
                  ticket__add: projectCode === '7days',
                  'button-new button-new__primary': projectCode === 'ukcarp'
                }"
                (click)="handleSubmit()"
                [disabled]="
                  isAddingToCart || isTooMuchTicketPerUser || !entranceAvailable
                "
                *ngIf="sliderMaxTickets !== 1"
              >
                <svg-icon
                  *ngIf="isAddingToCart"
                  name="circle-notch"
                  [spin]="true"
                  class="ticket__add-loading"
                ></svg-icon>
                {{ productPageText.ticketBoxBtn }}
                <svg-icon
                  name="ticket-small"
                  class="ticket__add-ticket"
                ></svg-icon>
              </button>

              <button
                [ngClass]="{
                  ticket__add: projectCode === '7days',
                  'button-new button-new__primary': projectCode === 'ukcarp'
                }"
                (click)="handleSubmit()"
                [disabled]="
                  isAddingToCart || isTooMuchTicketPerUser || !entranceAvailable
                "
                *ngIf="sliderMaxTickets === 1"
              >
                {{ productPageText.ticketBoxBtnOne }}
                <svg-icon
                  name="ticket-small"
                  class="ticket__add-ticket"
                ></svg-icon>
              </button>

              <button
                *ngIf="quickBuyConditions"
                [ngClass]="{
                  'button button_green button-new ticket__add green':
                    projectCode === '7days',
                  'button-new button-new__secondary': projectCode === 'ukcarp'
                }"
                (click)="handleInstantCheckout()"
                [disabled]="
                  isAddingToCart || isTooMuchTicketPerUser || !entranceAvailable
                "
              >
                {{
                  tokenizedCards.length
                    ? productPageText.ticketBoxBtnInstantCheckout
                    : productPageText.ticketBoxBtnBuyNow
                }}
              </button>

              <button
                [ngClass]="{
                  ticket__add: projectCode === '7days',
                  'button-new button-new__primary': projectCode === 'ukcarp'
                }"
                *ngIf="installAppMode"
                (click)="installApp()"
              >
                Install application
              </button>

              <button
                [ngClass]="{
                  ticket__add: projectCode === '7days',
                  'button-new button-new__primary': projectCode === 'ukcarp'
                }"
                *ngIf="openBrowserMode"
                (click)="openBrowser()"
              >
                Open browser
              </button>

              <div *ngIf="isTooMuchTicketPerUser" class="product__error">
                <ng-container
                  *ngIf="
                    sliderMaxTickets - cartItemQuantity > 0;
                    else checkCartMessage
                  "
                >
                  You can only add
                  {{ sliderMaxTickets - cartItemQuantity }}
                  more {{ productPageText.ticketBoxMaxTickets
                  }}{{ sliderMaxTickets - cartItemQuantity === 1 ? '' : 's' }}
                  to your cart
                </ng-container>
                <ng-template #checkCartMessage
                  >You already have max entries into this competition in your
                  basket.</ng-template
                >
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="product__tab-wrap" *ngIf="activeEntryOption === 'free'">
      <div
        class="product__tab-content product__postalentry"
        [ngClass]="{ 'product__postalentry-iw': isInstantWin }"
      >
        <div
          [ngClass]="{
            'product__postalentry-iw-container': isInstantWin
          }"
        >
          <p
            >Postal entries to this competition receive
            {{ product.tickets_added_per_postcard_entry }}
            {{ productPageText.entryOption | pluralize: product.tickets_added_per_postcard_entry}}.</p
          >

          <p
            >You may enter the competition using the Postal Entry Route by
            complying with the following conditions:</p
          >

          <ol type="a">
            <li>
              send your entry on an unenclosed postcard to the Promoter at the
              following address:
              <ng-container *ngIf="projectCode === '7days'">
                7days Performance Ltd, PO Box 100, Attleborough, NR17 2YU;
              </ng-container>
              <ng-container *ngIf="projectCode === 'ukcarp'">
                UK Carp Competitions Ltd, Unit 8 Diamond Point, Diamond Road,
                Norwich, NR66AW;
              </ng-container>
            </li>
            <li>
              include with your entry the following information:
              <ol type="I">
                <li>your full name;</li>
                <li>your address;</li>
                <li>a contact telephone number and email address;</li>
                <ng-container *ngIf="projectCode === '7days'">
                  <li
                    >your chosen competition<ng-container
                      *ngIf="!product.is_without_draw"
                      >, and your answer to the Competition
                      Question</ng-container
                    >.</li
                  >
                </ng-container>
                <ng-container *ngIf="projectCode === 'ukcarp'">
                  <li
                    >your chosen competition<ng-container
                      *ngIf="product.question"
                      >, and your answer to the Competition
                      Question</ng-container
                    >.</li
                  >
                </ng-container>
              </ol>
            </li>
            <li>incomplete or illegible entries will be disqualified;</li>
            <li>
              you may make multiple free entries for any competition (up to any
              limit placed on entries by the Promoter) but each free entry must
              be submitted and posted to the Promoter separately. Bulk entries
              will not be accepted as multiple entries and if a bulk entry is
              received, it will be counted as one single entry;
            </li>
            <li
              >by entering the competition, you are confirming that you are
              eligible to enter and accept these terms and conditions;</li
            >
            <li>
              your entry must be received by the Promoter prior to the Closing
              Date. Entries received after the Closing Date will not be entered
              into the random draw. If an entry is received by the Postal Entry
              Route within 72 hours after the Closing Date, the Entrant will
              receive a credit equal to the cost of entry via the Online Entry
              Route to the draw, which will enable the Entrant to enter an
              alternative draw(s) of their choice on the Website/App using the
              Online Entry Route;
            </li>
            <li
              >the Promoter will email each Entrant who has submitted a valid
              entry via the Postal Entry Route to confirm their
              {{ productPageText.entryOption }} number;</li
            >
            <li>
              Entrants must have created an account on the Website/App for the
              free entry to be processed. All details on the postcard must
              correspond to the details on the account to receive the order
              confirmation and
              {{ productPageText.entryOption }} number. Postal entries received
              without a registered account cannot be processed. Entrants must
              add an address to the related account for entries to be processed.
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
  <div class="product__rating" *ngIf="!isInstantWin && trustpilotConfig">
    <app-trustpilot
      [height]="'40px'"
      [config]="trustpilotConfig"
    ></app-trustpilot>
  </div>
</ng-container>
